import React, { useState, useCallback, useMemo } from 'react';

import {
  Table,
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Box,
  TableBody,
  TableHead,
} from '@material-ui/core';
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';
import PropTypes from 'prop-types';

export default function MinimizableTableRow({ cells, data, heading }) {
  const [open, setOpen] = useState(false);

  const firstCells = useMemo(() => cells.shift(), [cells]);

  const handleToggleOpen = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={handleToggleOpen}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>

        <TableCell component="th" scope="row">
          {data[firstCells]}
        </TableCell>

        {cells.map((cell, index) => (
          <TableCell align="right" key={index}>
            {data[cell]}
          </TableCell>
        ))}
      </TableRow>

      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={Number(cells.length + 2)}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small">
                <TableBody>
                  {data.repeat.map((r, index) => (
                    <TableRow key={index}>
                      <TableCell />
                      {heading.map((cell, key) => (
                        <TableCell key={key} align="right">
                          {r[cell.id]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

MinimizableTableRow.propTypes = {
  cells: PropTypes.arrayOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  heading: PropTypes.arrayOf(PropTypes.any).isRequired,
};
